import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useLayoutEffect, useState } from 'react';

var addZeroToSingleDigit = function addZeroToSingleDigit(digit) {
  var digitString = "".concat(digit);
  return digitString.length === 1 ? "0".concat(digitString) : digitString;
};

var getMMSSTime = function getMMSSTime(time) {
  var minutes = Math.floor(time / 60);
  var seconds = time - minutes * 60;
  return "".concat(addZeroToSingleDigit(minutes), ":").concat(addZeroToSingleDigit(seconds));
};

var getInitialState = function getInitialState(seconds) {
  return {
    seconds: seconds,
    time: getMMSSTime(seconds)
  };
};

export var useTimer = function useTimer(initialSeconds, isLoading) {
  var _useState = useState(getInitialState(initialSeconds)),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    if (!state.seconds) {
      return;
    }

    var timer = setInterval(function () {
      return setState(function (_ref) {
        var seconds = _ref.seconds;
        var isZero = seconds === 0;
        isZero && clearInterval(timer);
        return {
          seconds: isZero ? seconds : --seconds,
          time: getMMSSTime(seconds)
        };
      });
    }, 1000);
    return function () {
      clearInterval(timer);
    };
  }, [state.seconds]);
  useLayoutEffect(function () {
    !isLoading && setState(getInitialState(initialSeconds));
  }, [initialSeconds, isLoading]);
  return state;
};